/*
 *###############################################################################
 *Module Name                   : ViewAllContentMaster.js                       #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Malisha Fernando                              #
 *Date                          : Monday, August 30th 2021, 10:14:01 am         #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState, useEffect } from "react"
import { CardText, Col, Row, Alert, Card, CardBody, Media } from "reactstrap"
import Invoice from "../../../pages/Invoices/card-invoice.js"
import Notifications from "../../../pages/Dashboard-crypto/notifications"
import SimpleBar from "simplebar-react"


import img1 from "../../../assets/images/companies/img-1.png"
import img2 from "../../../assets/images/companies/img-2.png"
import img3 from "../../../assets/images/companies/img-3.png"
import { Context } from "app-contexts/CommonContexts.js"
import { useContext } from "react"

const ViewAllContent = ({

}) => {

  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL

  useEffect(() => {
    getCommonNotifications()
  }, [])

  const {
    getCommonNotifications, notifications
  } = useContext(Context);


  function updatenotification(id) {


    var obj = JSON.parse(localStorage.getItem("authUser"))
    var LogUserType = obj[2]

    fetch(`${ApiURL}common/notification/update/${LogUserType}/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    })
      .then(Response => Response.json())
      .then(responseData => {
        getCommonNotifications()
      }).catch(error => {
        console.log("error", error)
      })
  }


  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          <CardText className="mb-0">
            <Row>
              <Col>
                <Card>
                  <CardBody>
                    <SimpleBar style={{ maxHeight: "390px" }}>
                      <ul className="list-group">
                        {notifications.map((records, key) => (
                          <li className="list-group-item border-1 mb-1">
                            <Media>
                              <div className="avatar-xs me-3">
                                <span className="avatar-title rounded-circle bg-light">
                                  <img src={img1} alt="" height="18" />
                                </span>
                              </div>
                              <Media body>
                                <div className="float-end">
                                  <p className="text-muted mb-0">
                                    <a className="btn btn-sm btn-outline-success" onClick={() => {
                                      updatenotification(records.notiID)
                                    }}> <i className="bx bx-check-circle" /> Mark As Read</a>
                                  </p>
                                </div>
                                <h5 className="font-size-14">{records.notiTitle}</h5>

                                <p className="text-muted">
                                  {records.notiMessage}
                                </p>
                                <div className="float-end">
                                  <p className="text-muted mb-0">
                                    <i className="mdi mdi-account me-1" /> Messaged By  {records.createdBy}
                                  </p>
                                </div>
                                <p className="text-muted mb-0">{records.createdOn.slice(0, 10)}</p>

                              </Media>
                            </Media>
                          </li>
                        ))}
                      </ul>
                    </SimpleBar>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </CardText>
        </Col>
      </div>
    </React.Fragment>
  )
}

export default ViewAllContent
